import { styled } from 'styled-components'
import Button from 'mixtiles-web-common/ui/Button'
import ResponsiveSheet from '../../../components/ResponsiveSheet/ResponsiveSheet'

// Styles the sheet's scroll area so bottom-pinned children (margin-top: auto)
// hug the footer when the sheet has spare height.
export const CartSheet = styled(ResponsiveSheet)`
  display: flex;
  flex-direction: column;
`

export const Footer = styled.div`
  display: flex;
  padding: 12px 20px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  position: sticky;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.grayMedium};
`

export const CheckoutButtons = styled.div`
  display: flex;
  gap: 8px;
  align-self: stretch;

  > * {
    flex: 1 1 0;
    min-width: 0;
  }
`

export const CheckoutButton = styled(Button)`
  width: 100%;
`

export const FreeShippingMessage = styled.div`
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  text-align: center;
`
